<template>
	<div>
		<el-cascader
			:options="datas"
			:size="size"
			expand-trigger="click"
			:change-on-select="!isLastLevel"
			:show-all-levels="true"
			filterable
			clearable
			:props="{value:'id',label:'name'}"
			v-model="infoInput"
			@change="handleChange"
		></el-cascader>
	</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			infoInput: [],
			isLastLevel: false,
			inited: false,
			myValue: ""
		};
	},
	computed: {
		...mapState(["classifies"])
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			}
		},
		datas: {
			type: Array,
			default: () => {
				return [];
			}
		},
		size: {
			type: String,
			default: ""
		}
	},
	mounted() {
		if (this.params && this.params.isLastLevel) {
			this.isLastLevel = this.params.isLastLevel;
		}
		this.myValue = "";
	},
	methods: {
		...mapMutations(["getClassifies"]),

		refreshData(name) {
			this.getClassifies(false);
		},
		handleChange(val) {
			console.log("infoInput", val);
			let realVal;

			realVal = this.infoInput.map(val => {
				return { id: val };
			});

			this.$emit("change", realVal);
			this.$emit("input", realVal);
		}
	},
	watch: {
		value: {
			handler(val) {
				if (this.inited) {
					return;
				}
				if (!val || val.length == 0) {
					return;
				}
				this.inited = true;

				this.infoInput = [];
				val.forEach(element => {
					this.infoInput.push(element.id);
				});
			},
			immediate: true
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
